/**
 * @fileoverview This file is generated by the Angular 2 template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties}
 */
 /* tslint:disable */

import * as import0 from '../../../../../src/app/language-selector/components/language-selector.component';
import * as import1 from '@angular/core/src/linker/view';
import * as import2 from '@angular/core/src/render/api';
import * as import3 from '@angular/core/src/linker/view_utils';
import * as import4 from '@angular/core/src/metadata/view';
import * as import5 from '../../../../../src/app/language-selector/services/language-config.service';
import * as import6 from '../../../../../src/app/language-selector/services/language-user-preference.service';
import * as import7 from '@angular/core/src/linker/view_type';
import * as import8 from '@angular/core/src/change_detection/constants';
import * as import9 from '@angular/core/src/linker/component_factory';
import * as import10 from '../../../../../src/app/shared/services/config.service';
import * as import11 from 'ng2-translate/src/translate.service';
import * as import12 from '../../../../../$$_gendir/node_modules/@angular/forms/src/directives/select_control_value_accessor.ngfactory';
import * as import13 from '../../../../../$$_gendir/node_modules/@angular/forms/src/directives/select_multiple_control_value_accessor.ngfactory';
import * as import14 from '@angular/core/src/linker/view_container';
import * as import15 from '@angular/core/src/change_detection/change_detection_util';
import * as import16 from '@angular/core/src/linker/element_ref';
import * as import17 from '@angular/forms/src/directives/select_control_value_accessor';
import * as import18 from '@angular/forms/src/directives/select_multiple_control_value_accessor';
import * as import19 from '../../../../../$$_gendir/node_modules/@angular/forms/src/directives/ng_model.ngfactory';
import * as import20 from '../../../../../$$_gendir/node_modules/@angular/forms/src/directives/ng_control_status.ngfactory';
import * as import21 from '../../../../../$$_gendir/node_modules/@angular/common/src/directives/ng_for.ngfactory';
import * as import22 from 'ng2-translate/src/translate.pipe';
import * as import23 from '@angular/core/src/linker/template_ref';
import * as import24 from '@angular/core/src/change_detection/differs/iterable_differs';
import * as import25 from '@angular/common/src/directives/ng_for';
import * as import26 from '@angular/forms/src/directives/control_value_accessor';
import * as import27 from '@angular/forms/src/directives/ng_model';
import * as import28 from '@angular/forms/src/directives/ng_control';
import * as import29 from '@angular/forms/src/directives/ng_control_status';
export class Wrapper_LanguageSelectorComponent {
  /*private*/ _eventHandler:Function;
  context:import0.LanguageSelectorComponent;
  /*private*/ _changed:boolean;
  constructor(p0:any,p1:any) {
    this._changed = false;
    this.context = new import0.LanguageSelectorComponent(p0,p1);
  }
  ngOnDetach(view:import1.AppView<any>,componentView:import1.AppView<any>,el:any):void {
  }
  ngOnDestroy():void {
  }
  ngDoCheck(view:import1.AppView<any>,el:any,throwOnChange:boolean):boolean {
    var changed:any = this._changed;
    this._changed = false;
    return changed;
  }
  checkHost(view:import1.AppView<any>,componentView:import1.AppView<any>,el:any,throwOnChange:boolean):void {
  }
  handleEvent(eventName:string,$event:any):boolean {
    var result:boolean = true;
    return result;
  }
  subscribe(view:import1.AppView<any>,_eventHandler:any):void {
    this._eventHandler = _eventHandler;
  }
}
var renderType_LanguageSelectorComponent_Host:import2.RenderComponentType = import3.createRenderComponentType('',0,import4.ViewEncapsulation.None,([] as any[]),{});
class View_LanguageSelectorComponent_Host0 extends import1.AppView<any> {
  _el_0:any;
  compView_0:import1.AppView<import0.LanguageSelectorComponent>;
  _LanguageConfigService_0_3:import5.LanguageConfigService;
  _LanguageUserPreferenceService_0_4:import6.LanguageUserPreferenceService;
  _LanguageSelectorComponent_0_5:Wrapper_LanguageSelectorComponent;
  constructor(viewUtils:import3.ViewUtils,parentView:import1.AppView<any>,parentIndex:number,parentElement:any) {
    super(View_LanguageSelectorComponent_Host0,renderType_LanguageSelectorComponent_Host,import7.ViewType.HOST,viewUtils,parentView,parentIndex,parentElement,import8.ChangeDetectorStatus.CheckAlways);
  }
  createInternal(rootSelector:string):import9.ComponentRef<any> {
    this._el_0 = import3.selectOrCreateRenderHostElement(this.renderer,'obpa-language-selector',import3.EMPTY_INLINE_ARRAY,rootSelector,(null as any));
    this.compView_0 = new View_LanguageSelectorComponent0(this.viewUtils,this,0,this._el_0);
    this._LanguageConfigService_0_3 = new import5.LanguageConfigService(this.injectorGet(import10.ConfigService,this.parentIndex));
    this._LanguageUserPreferenceService_0_4 = new import6.LanguageUserPreferenceService(this._LanguageConfigService_0_3);
    this._LanguageSelectorComponent_0_5 = new Wrapper_LanguageSelectorComponent(this.injectorGet(import11.TranslateService,this.parentIndex),this._LanguageUserPreferenceService_0_4);
    this.compView_0.create(this._LanguageSelectorComponent_0_5.context);
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [this._el_0]),(null as any));
    return new import9.ComponentRef_<any>(0,this,this._el_0,this._LanguageSelectorComponent_0_5.context);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import5.LanguageConfigService) && (0 === requestNodeIndex))) { return this._LanguageConfigService_0_3; }
    if (((token === import6.LanguageUserPreferenceService) && (0 === requestNodeIndex))) { return this._LanguageUserPreferenceService_0_4; }
    if (((token === import0.LanguageSelectorComponent) && (0 === requestNodeIndex))) { return this._LanguageSelectorComponent_0_5.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    this._LanguageSelectorComponent_0_5.ngDoCheck(this,this._el_0,throwOnChange);
    this.compView_0.internalDetectChanges(throwOnChange);
  }
  destroyInternal():void {
    this.compView_0.destroy();
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
}
export const LanguageSelectorComponentNgFactory:import9.ComponentFactory<import0.LanguageSelectorComponent> = new import9.ComponentFactory<import0.LanguageSelectorComponent>('obpa-language-selector',View_LanguageSelectorComponent_Host0,import0.LanguageSelectorComponent);
const styles_LanguageSelectorComponent:any[] = ([] as any[]);
class View_LanguageSelectorComponent1 extends import1.AppView<any> {
  _el_0:any;
  _NgSelectOption_0_3:import12.Wrapper_NgSelectOption;
  _NgSelectMultipleOption_0_4:import13.Wrapper_NgSelectMultipleOption;
  _text_1:any;
  /*private*/ _expr_4:any;
  constructor(viewUtils:import3.ViewUtils,parentView:import1.AppView<any>,parentIndex:number,parentElement:any,declaredViewContainer:import14.ViewContainer) {
    super(View_LanguageSelectorComponent1,renderType_LanguageSelectorComponent,import7.ViewType.EMBEDDED,viewUtils,parentView,parentIndex,parentElement,import8.ChangeDetectorStatus.CheckAlways,declaredViewContainer);
    this._expr_4 = import15.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import9.ComponentRef<any> {
    this._el_0 = import3.createRenderElement(this.renderer,(null as any),'option',import3.EMPTY_INLINE_ARRAY,(null as any));
    this._NgSelectOption_0_3 = new import12.Wrapper_NgSelectOption(new import16.ElementRef(this._el_0),this.renderer,(<View_LanguageSelectorComponent0>this.parentView)._SelectControlValueAccessor_5_3.context);
    this._NgSelectMultipleOption_0_4 = new import13.Wrapper_NgSelectMultipleOption(new import16.ElementRef(this._el_0),this.renderer,(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'',(null as any));
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [
      this._el_0,
      this._text_1
    ]
    ),(null as any));
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import17.NgSelectOption) && ((0 <= requestNodeIndex) && (requestNodeIndex <= 1)))) { return this._NgSelectOption_0_3.context; }
    if (((token === import18.NgSelectMultipleOption) && ((0 <= requestNodeIndex) && (requestNodeIndex <= 1)))) { return this._NgSelectMultipleOption_0_4.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const currVal_0_0_0:any = this.context.$implicit[0];
    this._NgSelectOption_0_3.check_ngValue(currVal_0_0_0,throwOnChange,false);
    this._NgSelectOption_0_3.ngDoCheck(this,this._el_0,throwOnChange);
    const currVal_0_1_0:any = this.context.$implicit[0];
    this._NgSelectMultipleOption_0_4.check_ngValue(currVal_0_1_0,throwOnChange,false);
    this._NgSelectMultipleOption_0_4.ngDoCheck(this,this._el_0,throwOnChange);
    const currVal_4:any = import3.inlineInterpolate(1,'',this.context.$implicit[1],'');
    if (import3.checkBinding(throwOnChange,this._expr_4,currVal_4)) {
      this.renderer.setText(this._text_1,currVal_4);
      this._expr_4 = currVal_4;
    }
  }
  destroyInternal():void {
    this._NgSelectOption_0_3.ngOnDestroy();
    this._NgSelectMultipleOption_0_4.ngOnDestroy();
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
}
var renderType_LanguageSelectorComponent:import2.RenderComponentType = import3.createRenderComponentType('',0,import4.ViewEncapsulation.None,styles_LanguageSelectorComponent,{});
export class View_LanguageSelectorComponent0 extends import1.AppView<import0.LanguageSelectorComponent> {
  _el_0:any;
  _text_1:any;
  _el_2:any;
  _el_3:any;
  _text_4:any;
  _el_5:any;
  _SelectControlValueAccessor_5_3:import12.Wrapper_SelectControlValueAccessor;
  _NG_VALUE_ACCESSOR_5_4:any[];
  _NgModel_5_5:import19.Wrapper_NgModel;
  _NgControl_5_6:any;
  _NgControlStatus_5_7:import20.Wrapper_NgControlStatus;
  _text_6:any;
  _anchor_7:any;
  /*private*/ _vc_7:import14.ViewContainer;
  _TemplateRef_7_5:any;
  _NgFor_7_6:import21.Wrapper_NgFor;
  _text_8:any;
  _text_9:any;
  _text_10:any;
  /*private*/ _expr_19:any;
  _pipe_translate_0:import22.TranslatePipe;
  constructor(viewUtils:import3.ViewUtils,parentView:import1.AppView<any>,parentIndex:number,parentElement:any) {
    super(View_LanguageSelectorComponent0,renderType_LanguageSelectorComponent,import7.ViewType.COMPONENT,viewUtils,parentView,parentIndex,parentElement,import8.ChangeDetectorStatus.CheckAlways);
    this._expr_19 = import15.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import9.ComponentRef<any> {
    const parentRenderNode:any = this.renderer.createViewRoot(this.parentElement);
    this._el_0 = import3.createRenderElement(this.renderer,parentRenderNode,'div',new import3.InlineArray2(2,'class','input-group input-group-sm'),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'\n    ',(null as any));
    this._el_2 = import3.createRenderElement(this.renderer,this._el_0,'span',new import3.InlineArray2(2,'class','input-group-addon'),(null as any));
    this._el_3 = import3.createRenderElement(this.renderer,this._el_2,'span',new import3.InlineArray4(4,'aria-hidden','true','class','glyphicon glyphicon-globe'),(null as any));
    this._text_4 = this.renderer.createText(this._el_0,'\n    ',(null as any));
    this._el_5 = import3.createRenderElement(this.renderer,this._el_0,'select',new import3.InlineArray2(2,'class','form-control'),(null as any));
    this._SelectControlValueAccessor_5_3 = new import12.Wrapper_SelectControlValueAccessor(this.renderer,new import16.ElementRef(this._el_5));
    this._NG_VALUE_ACCESSOR_5_4 = [this._SelectControlValueAccessor_5_3.context];
    this._NgModel_5_5 = new import19.Wrapper_NgModel((null as any),(null as any),(null as any),this._NG_VALUE_ACCESSOR_5_4);
    this._NgControl_5_6 = this._NgModel_5_5.context;
    this._NgControlStatus_5_7 = new import20.Wrapper_NgControlStatus(this._NgControl_5_6);
    this._text_6 = this.renderer.createText(this._el_5,'\n        ',(null as any));
    this._anchor_7 = this.renderer.createTemplateAnchor(this._el_5,(null as any));
    this._vc_7 = new import14.ViewContainer(7,5,this,this._anchor_7);
    this._TemplateRef_7_5 = new import23.TemplateRef_(this,7,this._anchor_7);
    this._NgFor_7_6 = new import21.Wrapper_NgFor(this._vc_7.vcRef,this._TemplateRef_7_5,this.parentView.injectorGet(import24.IterableDiffers,this.parentIndex),this.ref);
    this._text_8 = this.renderer.createText(this._el_5,'\n    ',(null as any));
    this._text_9 = this.renderer.createText(this._el_0,'\n',(null as any));
    this._text_10 = this.renderer.createText(parentRenderNode,'\n',(null as any));
    var disposable_0:Function = import3.subscribeToRenderElement(this,this._el_5,new import3.InlineArray8(6,'ngModelChange',(null as any),'change',(null as any),'blur',(null as any)),this.eventHandler(this.handleEvent_5));
    this._NgModel_5_5.subscribe(this,this.eventHandler(this.handleEvent_5),true);
    this._pipe_translate_0 = new import22.TranslatePipe(this.parentView.injectorGet(import11.TranslateService,this.parentIndex),this.ref);
    this.init((null as any),((<any>this.renderer).directRenderer? (null as any): [
      this._el_0,
      this._text_1,
      this._el_2,
      this._el_3,
      this._text_4,
      this._el_5,
      this._text_6,
      this._anchor_7,
      this._text_8,
      this._text_9,
      this._text_10
    ]
    ),[disposable_0]);
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import23.TemplateRef) && (7 === requestNodeIndex))) { return this._TemplateRef_7_5; }
    if (((token === import25.NgFor) && (7 === requestNodeIndex))) { return this._NgFor_7_6.context; }
    if (((token === import17.SelectControlValueAccessor) && ((5 <= requestNodeIndex) && (requestNodeIndex <= 8)))) { return this._SelectControlValueAccessor_5_3.context; }
    if (((token === import26.NG_VALUE_ACCESSOR) && ((5 <= requestNodeIndex) && (requestNodeIndex <= 8)))) { return this._NG_VALUE_ACCESSOR_5_4; }
    if (((token === import27.NgModel) && ((5 <= requestNodeIndex) && (requestNodeIndex <= 8)))) { return this._NgModel_5_5.context; }
    if (((token === import28.NgControl) && ((5 <= requestNodeIndex) && (requestNodeIndex <= 8)))) { return this._NgControl_5_6; }
    if (((token === import29.NgControlStatus) && ((5 <= requestNodeIndex) && (requestNodeIndex <= 8)))) { return this._NgControlStatus_5_7.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const valUnwrapper:any = new import15.ValueUnwrapper();
    this._SelectControlValueAccessor_5_3.ngDoCheck(this,this._el_5,throwOnChange);
    const currVal_5_1_0:any = this.context.selectedLanguage;
    this._NgModel_5_5.check_model(currVal_5_1_0,throwOnChange,false);
    this._NgModel_5_5.ngDoCheck(this,this._el_5,throwOnChange);
    this._NgControlStatus_5_7.ngDoCheck(this,this._el_5,throwOnChange);
    const currVal_7_0_0:any = this.context.languages;
    this._NgFor_7_6.check_ngForOf(currVal_7_0_0,throwOnChange,false);
    this._NgFor_7_6.ngDoCheck(this,this._anchor_7,throwOnChange);
    this._vc_7.detectChangesInNestedViews(throwOnChange);
    valUnwrapper.reset();
    const currVal_19:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_0.transform('LANGUAGE')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_19,currVal_19))) {
      this.renderer.setElementAttribute(this._el_5,'aria-label',((currVal_19 == null)? (null as any): currVal_19.toString()));
      this._expr_19 = currVal_19;
    }
    this._NgControlStatus_5_7.checkHost(this,this,this._el_5,throwOnChange);
  }
  destroyInternal():void {
    this._vc_7.destroyNestedViews();
    this._NgModel_5_5.ngOnDestroy();
    this._pipe_translate_0.ngOnDestroy();
  }
  createEmbeddedViewInternal(nodeIndex:number):import1.AppView<any> {
    if ((nodeIndex == 7)) { return new View_LanguageSelectorComponent1(this.viewUtils,this,7,this._anchor_7,this._vc_7); }
    return (null as any);
  }
  handleEvent_5(eventName:string,$event:any):boolean {
    this.markPathToRootAsCheckOnce();
    var result:boolean = true;
    result = (this._SelectControlValueAccessor_5_3.handleEvent(eventName,$event) && result);
    if ((eventName == 'ngModelChange')) {
      const pd_sub_0:any = ((<any>this.context.setLanguage($event)) !== false);
      result = (pd_sub_0 && result);
    }
    return result;
  }
}


// WEBPACK FOOTER //
// ./$$_gendir/src/app/language-selector/components/language-selector.component.ngfactory.ts